import { render, staticRenderFns } from "./LandedCostComponentCreateView.vue?vue&type=template&id=4ab9221e"
import script from "./LandedCostComponentCreateView.vue?vue&type=script&lang=js"
export * from "./LandedCostComponentCreateView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports